<template>
  <div class="custom-table-header">
    <div v-for="header in headers" :class="`custom-tr ${header.class} ${header.prop === 'actions' ? 'd-flex justify-content-center' : ''}`" :style="`min-width: ${header.minWidth}px;`">
      <p>{{ header.name }}</p>
    </div>
  </div>
</template>
<script>
export default {
  name: "TableHeader",
  props: {
    headers: {
      type: Array,
      required: true,
    }
  }
}
</script>
<style scoped lang="scss">
@import "src/assets/sass/now-ui-dashboard/variables.scss";

.custom-table-header {
  height: 50px;
  display: flex;
  flex-wrap: nowrap;
  flex-direction: row;
  min-width: 100%;
  height: 100%;

  .custom-tr {
    padding: .7em .9em;
    width: 100%;

    p {
      padding: 0;
      margin: 0;
      color: $secondary-color;
      font-weight: 700;
    }
  }
}
</style>
